/** Level qualification rules — mirrors T&C / product spec. */

export const ACTIVE_DIRECT_REFERRAL_POLICY =
  "A direct referral counts when they are linked to you in the referrals collection " +
  "and have at least one Auto Fill program with status active (₹150 AFP purchased).";

export const ULTRA_DIRECT_REFERRAL_POLICY =
  "A direct referral counts when they are linked to you in the referrals collection " +
  "and have purchased the Ultra / membership activation package (hasPurchasedPackage).";

export const AUTO_FILL_TERMS_VERSION = "2026-01";

export const PROGRAM_WALLET_FIELD = "autoFillProgramWalletAddress";
export const PROGRAM_WALLET_VERIFIED_FIELD = "autoFillProgramWalletVerified";
